import { t } from 'i18next';
import { openNewTab } from '../../utils/UIUtils';
import { FabSheet } from '../../presentation/components';

interface LocationRegisterCardProps {
  artistId: string;
}

const LocationRegisterCard = ({ artistId }: LocationRegisterCardProps) => {
  return (
    <div className="max-w-[calc(100%-48px)] mx-auto rounded-[13px] p-[1px] bg-gradient-to-r from-[#458FFF] to-[#CF6AFF]">
      <div className="flex flex-col gap-[16px] items-center px-[20px] py-[24px] rounded-[12px] bg-background-light dark:bg-pure-black">
        <div className="flex flex-col items-center gap-[6px] leading-none">
          <p className="text-[17px] font-bold text-text-main-lv2">
            {t('OfflineLocation.noLocation', {
              defaultValue: '찾고 있는 장소가 없나요?'
            })}
          </p>
          <p className="text-[13px] text-text-main-lv3">
            {t('OfflineLocation.noLocationDescription', {
              defaultValue: '새로운 장소를 등록할 수 있어요!'
            })}
          </p>
        </div>
        <div>
          <FabSheet
            text={
              t('OfflineLocation.registerButton', {
                defaultValue: '등록하기'
              }) as string
            }
            onClick={() =>
              openNewTab(`/report/select-member?reportType=event&artistId=${artistId}`)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default LocationRegisterCard;
